import React, { useState, useEffect } from 'react';
import { warrantyService } from '../api/warrantyService';
import Table from '../components/Common/Table';
import Pagination from '../components/Common/Pagination';
import SearchBar from '../components/Common/SearchBar';
import Modal from '../components/Common/Modal';
import '../components/Common/Common.css';

function Warranties() {
  const [warranties, setWarranties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showExtendModal, setShowExtendModal] = useState(false);
  const [selectedWarranty, setSelectedWarranty] = useState(null);
  const [extendMonths, setExtendMonths] = useState(12);

  const fetchWarranties = async () => {
    try {
      setLoading(true);
      const response = await warrantyService.getWarranties({
        page: currentPage,
        uuid: searchTerm,
        per_page: 15,
      });
      setWarranties(response.data || []);
      setLastPage(response.last_page || 1);
    } catch (error) {
      console.error('Error fetching warranties:', error);
      setWarranties([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWarranties();
  }, [currentPage, searchTerm]);

  const handleExtend = async () => {
    try {
      await warrantyService.extendWarranty(selectedWarranty.id, extendMonths);
      setShowExtendModal(false);
      fetchWarranties();
    } catch (error) {
      console.error('Error extending warranty:', error);
      alert('Failed to extend warranty');
    }
  };

  const openExtendModal = (warranty) => {
    setSelectedWarranty(warranty);
    setShowExtendModal(true);
  };

  const columns = [
    { key: 'id', label: 'ID' },
    {
      key: 'uuid',
      label: 'UUID',
      render: (val) => (
        <span style={{ fontFamily: 'monospace', fontSize: '12px' }}>
          {val ? val.substring(0, 8) + '...' : 'N/A'}
        </span>
      )
    },
    {
      key: 'sale_item',
      label: 'Produit',
      render: (val) => val?.product?.name || 'N/A'
    },
    {
      key: 'sale_item',
      label: 'Facture de vente',
      render: (val) => val?.sale?.invoice_uuid || 'N/A'
    },
    {
      key: 'start_date',
      label: 'Date de début',
      render: (val) => val ? new Date(val).toLocaleDateString('fr-FR') : 'N/A'
    },
    {
      key: 'end_date',
      label: 'Date de fin',
      render: (val) => val ? new Date(val).toLocaleDateString('fr-FR') : 'N/A'
    },
    {
      key: 'end_date',
      label: 'Statut',
      render: (val) => {
        if (!val) return <span className="badge badge-secondary">Inconnu</span>;
        const endDate = new Date(val);
        const today = new Date();
        const isActive = endDate >= today;
        return (
          <span className={`badge ${isActive ? 'badge-success' : 'badge-danger'}`}>
            {isActive ? 'Active' : 'Expirée'}
          </span>
        );
      }
    },
    {
      key: 'extended',
      label: 'Prolongée',
      render: (val) => <span className={`badge ${val ? 'badge-info' : 'badge-secondary'}`}>{val ? 'Oui' : 'Non'}</span>
    },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Garanties</h1>
      </div>

      <div className="filters">
        <div className="filters-grid">
          <div style={{ gridColumn: 'span 2' }}>
            <SearchBar
              value={searchTerm}
              onChange={setSearchTerm}
              placeholder="Rechercher des garanties par UUID ou nom de produit..."
              onClear={() => setCurrentPage(1)}
            />
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        data={warranties}
        loading={loading}
        onEdit={openExtendModal}
        actions={true}
      />

      <Pagination
        currentPage={currentPage}
        lastPage={lastPage}
        onPageChange={setCurrentPage}
      />

      <Modal
        isOpen={showExtendModal}
        onClose={() => setShowExtendModal(false)}
        title="Prolonger la garantie"
        size="small"
      >
        <div className="form-group">
          <label>Période de prolongation (Mois)</label>
          <input
            type="number"
            min="1"
            max="60"
            value={extendMonths}
            onChange={(e) => setExtendMonths(parseInt(e.target.value))}
          />
        </div>
        <div className="form-actions">
          <button onClick={() => setShowExtendModal(false)} className="btn btn-secondary">
            Annuler
          </button>
          <button onClick={handleExtend} className="btn btn-primary">
            Prolonger
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default Warranties;
